import { QueryClientProvider} from "react-query";
import Box from "@mui/material/Box";
import {EquipmentsPage} from "./EquipmentsPage";
import {sharedQueryClient as queryClient} from "../../../queryClient";

export function CommunicationEquipmentsPage() {
    return(
        <QueryClientProvider client={queryClient}>
            <Box sx={{
                marginTop: 1,
                marginRight: 3
            }}>
                <EquipmentsPage />
            </Box>
        </QueryClientProvider>
    );
}